// customers-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'cus.row.noOpenAlerts': 'No open alerts',
  'cus.row.openPage': 'Open page',
  'cus.row.openTasks': 'Open tasks',
  'cus.row.noOpenTasks': 'No open tasks',
  'cus.row.openDeviations': 'Open deviations',
  'cus.row.waitingForClient': 'Waiting for the client',
  'cus.row.upcomingDeadlines': 'Upcoming deadlines',
  'cus.row.noNearDeadlines': 'No near deadlines',
  'cus.row.lastActivity': 'Latest activity',
  'cus.row.savedInAccounts': 'saved in the accounts',
  'cus.row.noActivity': 'No activity recorded',
  'cus.row.shortcuts': 'Shortcuts',
  'cus.row.openTheClient': 'Open the client',
  'cus.row.aiAccountant': 'AI Accountant',
  'cus.row.disciplines': 'Areas of expertise',
  'cus.row.openChatWith': 'Open chat with {name} – {status}',
  'cus.row.hideDetailsFor': 'Hide details for {name}',
  'cus.row.showDetailsFor': 'Show details for {name}',
  'cus.row.orgNumber': 'Org. {org}',
  'cus.row.noOrgNumber': 'No org. no.',
  'cus.row.noResponsible': 'No one responsible',
  'cus.row.chatWith': 'Chat with {name}',
  'cus.row.chat': 'Chat',
  'cus.row.openClient': 'Open client',
  'cus.row.collapse': 'Hide {name}',
  'cus.row.showMoreAbout': 'Show more about {name}',
  'cus.merge.headline': 'Did you create the same customer twice?',
  'cus.merge.help': 'Select the duplicate. Invoices are moved to the customer that is kept, and the other customer is removed.',
  'cus.merge.whichSame': 'Which customer is the same as {name}?',
  'cus.merge.selectCustomer': 'Select customer...',
  'cus.address.searching': 'Searching official addresses...',
  'cus.chat.loadFailed': 'Could not load the customer dialogue.',
  'cus.chat.notConnected': 'Customer dialogue is not connected to the backend.',
  'cus.chat.newStarted': 'New conversation started {date}',
  'cus.chat.newFailed': 'Could not start a new conversation.',
  'cus.chat.quoteBasisFailed': 'Could not save the quote basis.',
  'cus.chat.offerCreated': 'Quote draft created for {name}',
  'cus.chat.offerFailed': 'Could not create the quote.',
  'cus.chat.savedInDialog': 'Message saved in the dialogue',
  'cus.chat.customerMessageSaved': 'Customer message saved',
  'cus.chat.internalNoteSaved': 'Internal note saved',
  'cus.chat.saveFailed': 'Could not save the message.',
  'cus.chat.sent': 'Message sent to the customer',
  'cus.chat.sendFailed': 'Could not save or send the message.',
  'cus.chat.modalTitle': 'Conversation - {name}',
  'cus.chat.dialogN': 'Dialogue {n} · {date}',
  'cus.chat.newConversation': 'New conversation ({date})',
  'cus.chat.readyForQuote': 'Ready for quote',
  'cus.chat.chipDialog': 'Customer dialogue',
  'cus.chat.noMessages': 'No messages in this view.',
  'cus.chat.sumExVat': 'Total excl. VAT',
  'cus.chat.vat25': 'VAT (25%)',
});
